import api from './api'

// Clave pública VAPID — es pública por diseño, no requiere estar en un .env
const VAPID_PUBLIC_KEY = 'BMlRRMt_CuLQY7iTQazJ74tFeejw4-VSsbQ0iTbQJUVh-sXjAEG5LeTApsA2hIBjQr5G-KkHekYeuzlclwDUL8g'

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4)
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/')
  const rawData = window.atob(base64)
  return Uint8Array.from([...rawData].map((c) => c.charCodeAt(0)))
}

// Suscribe este dispositivo/navegador a notificaciones push del sistema
export async function suscribirPush() {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) return

  try {
    const registration = await navigator.serviceWorker.ready
    let subscription = await registration.pushManager.getSubscription()

    if (!subscription) {
      subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY),
      })
    }

    await api.post('/push/subscribe', { subscription: subscription.toJSON() })
  } catch (err) {
    console.error('Error suscribiendo a push:', err)
  }
}

// Desuscribe este dispositivo (logout / desactivar notificaciones)
export async function desuscribirPush() {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) return

  try {
    const registration = await navigator.serviceWorker.ready
    const subscription = await registration.pushManager.getSubscription()
    if (!subscription) return

    const authToken = localStorage.getItem('token')
    await api.post('/push/unsubscribe', { endpoint: subscription.endpoint }, {
      headers: authToken ? { Authorization: `Bearer ${authToken}` } : {},
    })
    await subscription.unsubscribe()
  } catch (err) {
    console.error('Error desuscribiendo de push:', err)
  }
}
